export default "__VITE_ASSET__B5w6G3Ms__"